import { Box, Button } from "@mui/material";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import WalletOutlinedIcon from "@mui/icons-material/WalletOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import { NavLink } from "react-router-dom";
import { useConstants } from "../hooks/UseConstants";

export default function AdminFinanceNav() {
    const { language } = useConstants();
    const isAr = language === "ar";

    const items = [
        { to: "/financial", label: isAr ? "نظرة عامة" : "Overview", icon: <AccountBalanceWalletOutlinedIcon fontSize="small" /> },
        { to: "/financial/withdrawal-requests", label: isAr ? "طلبات السحب" : "Withdrawals", icon: <PaymentsOutlinedIcon fontSize="small" /> },
        { to: "/financial/financial-operations", label: isAr ? "الدفتر المالي" : "Ledger", icon: <ReceiptLongOutlinedIcon fontSize="small" /> },
        { to: "/wallet", label: isAr ? "المحفظة" : "Wallet", icon: <WalletOutlinedIcon fontSize="small" /> },
        { to: "/wallet/student-topup", label: isAr ? "شحن طالب" : "Student top-up", icon: <WalletOutlinedIcon fontSize="small" /> },
    ];

    return (
        <Box
            sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                mb: 2,
                p: 0.75,
                borderRadius: 2,
                bgcolor: "action.hover",
                border: "1px solid",
                borderColor: "divider",
            }}
        >
            {items.map((item) => (
                <Button
                    key={item.to}
                    component={NavLink}
                    to={item.to}
                    end={item.to === "/financial"}
                    startIcon={item.icon}
                    variant="text"
                    sx={{
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        borderRadius: 1.5,
                        color: "#64748b",
                        "&.active": {
                            bgcolor: "#0D358C",
                            color: "#fff",
                            "&:hover": { bgcolor: "#1a5bb8" },
                        },
                    }}
                >
                    {item.label}
                </Button>
            ))}
        </Box>
    );
}
